import React from 'react';

function Services() {
  return (
    <section id="services" className="section services-section">
      <div className="container">
        <h2>Was bieten wir an?</h2>
        <div className="services-grid">
          <div className="service-item">
            <h3>Textildruck</h3>
            <p>
              Wir bieten hochwertige Drucke für T-Shirts, Hoodies, Taschen und mehr.
              Dank Plottfolien von Namenhaften Herstellern sind unsere Drucke
              langlebig, farbenfroh und detailgenau. Perfekt für individuelle
              Designs und Firmenlogos.
            </p>
          </div>
          <div className="service-item">
            <h3>Sublimationsdruck</h3>
            <p>
              Mit modernster Technologie bieten wir brillante und langlebige Drucke
              auf einer Vielzahl von Textilien, Tassen und mehr. Ideal für
              personalisierte Geschenke, Werbematerialien und Firmenbekleidung.
            </p>
          </div>
          <div className="service-item">
            <h3>Aufkleber</h3>
            <p>
              Unsere Aufkleber bieten eine breite Palette von Anwendungsmöglichkeiten,
              sei es für Werbung, Dekoration oder persönliche Gestaltungen. Sie
              zeichnen sich durch ihre Langlebigkeit, vielseitige Verwendbarkeit
              und maßgeschneiderten Designs aus.
            </p>
          </div>
          <div className="service-item">
            <h3>Vieles mehr</h3>
            <p>
              Entdecken Sie unser umfangreiches Angebot an Druckdienstleistungen!
              Wir bieten hochwertigen Textildruck, präzisen Sublimationsdruck,
              vielseitige Aufkleber und viele weitere individuelle Drucklösungen
              für Ihre Bedürfnisse. Lassen Sie sich von unserer Qualität und unserem
              Service überzeugen!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;